import { useEffect, useState, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getHostingAccountById, getSingleHostingPageData } from "../../../api/user/active-services/hostings";
import { DISPLAY_LANG } from "../../../config";
import { errorMessage, getHostingPlans } from "../../../api/global";
import { CurrencyContext } from "../../../contexts/CurrencyContext";
import ModalHostingUpgradeBillingType from "./ModalHostingUpgradeBillingType";
import Loading from "../../../components/loading";
import axios from "../../../axios";
import "./hostingDetail.css";

const billingType = {
  'monthly': {
    en: 'Monthly',
    ru: 'Ежемесячно',
    am: 'Ամսական',
  },
  'yearly': {
    en: 'Yearly',
    ru: 'Ежегодно',
    am: 'Ամսական',
  }
};

const status = {
  'active': {
    en: 'Active',
    ru: 'Активен',
    am: 'Ակտիվ',
  },
  'inactive': {
    en: 'Suspended',
    ru: 'Приостановлено',
    am: 'Կասեցված',
  }
};

export default function HostingDetails() {
  const [pageData, setPageData] = useState({});
  const [hosting, setHosting] = useState({});
  const [loading, setLoading] = useState(true);
  const [showUpgradeDropdown, setShowUpgradeDropdown] = useState(false);
  const [cursorLoad, setCursorLoad] = useState(false);
  const [hostingPlans, setHostingPlans] = useState([]);
  const { id } = useParams();
  const { selectedCurrency } = useContext(CurrencyContext);
  const [showModal, setShowModal] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const loadingData = async () => {
      try {
        const data = await getHostingAccountById(id);
        setHosting(data);

        if (data.status === '400_ns') {
          alert(data[DISPLAY_LANG]);
          navigate('/user/hostings');
          return;
        }

        const resPageData = await getSingleHostingPageData(DISPLAY_LANG);
        setPageData(resPageData);

        const resHostingPlans = await getHostingPlans(DISPLAY_LANG);
        setHostingPlans(resHostingPlans);
        setLoading(false);
      } catch (error) {
        console.log(error);
      }
    };

    loadingData();
    window.scrollTo(0, 0);
  }, [id]);

  const handleAutoRenew = async (event) => {
    try {
      setCursorLoad(true);
      const res = await axios.patch("isp/auto_renew_hosting", {
        hosting_id: id,
        auto_renew: event.target.checked
      });

      if (res.status === 200) {
        setHosting({
          ...hosting,
          auto_renew: res.data.auto_renew,
        });
      }
    } catch (error) {
      console.log(error);
      alert(errorMessage[DISPLAY_LANG]);
    } finally {
      setCursorLoad(false);
    }
  };

  const handleUpgrade = (planBillingType) => {
    setCursorLoad(true);

    localStorage.setItem('100_HOSTING_UPGRADE_SELECTED_PLAN_NAME', selectedPlan.name);
    localStorage.setItem('100_HOSTING_UPGRADE_SELECTED_PLAN_BILLING_TYPE', planBillingType);
    localStorage.setItem('100_HOSTING_UPGRADE_CURRENT_USERNAME', hosting.isp_username);
    localStorage.setItem('100_HOSTING_UPGRADE_CURRENT_DOMAIN_NAME', hosting.domain);

    if (planBillingType === 'monthly') {
      localStorage.setItem("100_HOSTING_OLD_PRICE", hosting.price_mothly_amd);
    } else {
      localStorage.setItem("100_HOSTING_OLD_PRICE", hosting.price_yearly_amd);
    }

    navigate('/user/payment-method');
  };

  const handleRenew = () => {
    localStorage.setItem('200_HOSTING_RENEW_DOMAIN_NAME', hosting.domain);
    localStorage.setItem('200_HOSTING_RENEW_BILLING_TYPE', hosting.billing_type);
    navigate('/user/payment-method');
  };

  console.log(hosting);

  if (loading) {
    return <Loading />;
  }

  return (
    <div className="HosintgDetail wrapper" style={{ cursor: cursorLoad ? 'wait' : 'default' }}>
      {showModal && <ModalHostingUpgradeBillingType onClose={() => setShowModal(false)} onSelect={handleUpgrade} />}

      <div className="hosting_detail_top_side">
        <h1>{hosting.domain} ({hosting.plan})</h1>
        <p className={`status ${hosting.status_customer}`}>{status[hosting.status_customer][DISPLAY_LANG]}</p>
      </div>

      {hosting.plan !== 'Free' && <div className="hosting_detail_expire_date">
        <b>{pageData.expire_label}</b> {hosting.expire_date.split("T")[0]}
      </div>}

      <div className="hosting_detail_buttons flex-between">
        <div className="left-side">
          <a href="https://ispmgr.dotigo.net:1501/roundcube/" target="_blank" className="email_btn">
            <img src="/images/user_hosting_page/email.svg" alt="email" className="email" />
            {pageData.email_btn}
          </a>

          <a href={hosting.isp_user_login} className="btn_settings" target="_blank">
            <img src="/images/user_hosting_page/settings.svg" alt="settings" className="btn settings" />
            {pageData.isp_btn}
          </a>
        </div>

        <div className="right-side">
          {hosting.plan !== 'Free' && <a href="#" onClick={handleRenew}>{pageData.renew_btn}</a>}

          <div className="upgrade" onClick={() => setShowUpgradeDropdown(!showUpgradeDropdown)}>
            <img src="/images/user_hosting_page/upgrade.svg" alt="upgrade" />
            {pageData.upgarde_btn}

            <div className={`content-dropdown ${showUpgradeDropdown ? 'active' : ''}`}>
              {
                hostingPlans.map((plan, idx) => {
                  if (plan.name === hosting.plan || plan.name === 'Free') {
                    return null;
                  }

                  return (
                    <p key={idx} className="flex-between" onClick={() => { setShowModal(true); setSelectedPlan(plan); }}>
                      <span>{plan.name}</span>
                      <span>
                        {selectedCurrency.symbol === '$' ? '$ ' : ''}
                        {plan.prices.monthly[selectedCurrency.title]} / {plan.prices.yearly[selectedCurrency.title]}
                        {selectedCurrency.symbol !== '$' ? ' ' + selectedCurrency.symbol : ''}
                      </span>
                    </p>
                  )
                })
              }
            </div>
          </div>
        </div>
      </div>

      <div className="hosting_detail_hosting_info">
        <p><b>{pageData.hosting_package_label}</b><span> {hosting.plan}</span></p>
        <p><b>{pageData.username_label}</b><span> {hosting.isp_username}</span></p>

        {hosting.plan !== 'Free' && <p>
          <b>{pageData.auto_renew_label}</b>

          <span className="choose-paying-way flex-center">
            <label className="switch">
              <input
                type="checkbox"
                checked={hosting.auto_renew}
                onChange={handleAutoRenew}
              />

              <span className="slider"></span>
            </label>
          </span>
        </p>}

        <p><b>{pageData.domain_label}</b> {hosting.domain}</p>
        {hosting.plan !== 'Free' && <p><b>{pageData.billing_type_label}</b> {billingType[hosting.billing_type][DISPLAY_LANG]}</p>}

        <p>
          <b>{pageData.dns_labels}</b>
          <span className="dns-wrapper">
            <span className="value dns">{hosting["dns-servers"][0]}</span>
            <span className="value dns">{hosting["dns-servers"][1]}</span>
          </span>
        </p>
      </div>
    </div>
  );
}
